module.exports = __webpack_public_path__ + "img/3.2ad79d6d.png";